import { createSelector, MemoizedSelector } from '@ngrx/store';

import * as fromLoader from '../reducers/loader.reducer';
import { getLoaderState } from '../reducers';

export const isLoaderVisible: MemoizedSelector<object, boolean> = createSelector(
  getLoaderState,
  fromLoader.getIsVisible
);
